import Ajax from 'js/utils/ajax/ajax';

import { ApiServiceSupplier } from 'src/interfaces/interfaces.generated';

export const createServiceSupplier = (serviceSupplier: ApiServiceSupplier) =>
  Ajax.post('/shops/v1/servicesuppliers', serviceSupplier);
